import React from "react";
import  AmenityBookingNew  from "./amenityBookingNew";

class AmenityBookingParent extends React.Component {
    render() {
        return <AmenityBookingNew />
    }
}
export default AmenityBookingParent;
